import React from 'react'
import xtend from 'xtend'
import _ from 'underscore'
import { observ, struct, Model } from '@nichoth/observ'
import View from '../../misc-assets'
import config from '../../config'
const { uris, apiAuthentication } = config
import createModels from './create-models'
import subscribeToWebsocket from './subscribe-to-websocket'
var { createIo } = createModels
import { createRequestFn, slugify } from './util'
var CRUD_URL = uris.crud
var PULBLIC_URL = uris.public

function createApis ({ clientID }) {
    var publicApi = createRequestFn({
        clientID: clientID,
        host: PULBLIC_URL,
        headers: {
            authorization: apiAuthentication.vendorName,
            'wsc-api-key': apiAuthentication.vendorKey
        }
    })

    var crudApi = createRequestFn({
        clientID: clientID,
        host: CRUD_URL,
        headers: {
            authorization: apiAuthentication.vendorName,
            'wsc-api-key': apiAuthentication.vendorKey
        }
    })

    return { publicApi, crudApi }
}


// @TODO
// * [ ] an 'x' button to clear the search value
// * [ ] show the number of matches next to each item in the type select
// * [ ] save the state of the sorting in localStorage
// * [ ] use popup library for tooltips
// * [ ] css adjustments
//    - [ ] buttons on the cards should be gray with blue hover state
//    - [ ] controls in the filter section look ok
// * [ ] [feature] Adjust the size of the grid items
// * [x] show errors for xhr calls
// * [x] show status of uploads and transcodes as 'processing', maybe make
//       the style more distinct
// * [x] css is good at all screen widths -- small adjustments with the
//    size of the cards and how the lines of text break
// * [x] less latency between when the upload finishes and when you see
//   the placeholder in the list of assets. Could show an asset with
//   'uploading' status, then just delete it if the upload fails
// * [x] add filter setting so you can see only videos that are transciding
// * [x] view for assets that are transcoding
// * [x] listen for websocket messages
//   - [x] remove placeholders when we get asset/add with same ID
//   - [x] add, update, delete actions via websocket
//   - [x] all ws messages are idempotent with the xhr calls
// * [x] (feature) Can sort things -- Sort by: name | date | filesize,
//    asc/desc. Need to add a method to the observ package
// * [x] show number of results in the filter section
// * [x] uploads work better. There are some small problems -- cancelling
//     uploads doesn't work right, there's an odd 400 at some point in aws
// * [x] need to show placeholder after uploading an asset
// * [x] thumbnail in the image assets is a link to the file
// * [x] uploads are ok -- no error from crud (pass MISC as eventID)
// * [x] can search with a text input
// * [x] filter by filetype
// * [x] download buttons work
// * [x] show thumbnail icon for file types -- pdf, text, misc
// * [x] delete button works
// * [x] edit button works

function MiscAssetsRoute (api, ws, opts) {
    var apis = createApis({ clientID: opts.credentials.clientID })
    var io = createIo(apis)
    var models = createModels({ io })
    subscribeToWebsocket({ assets: models.assets, ws })

    if (process.env.NODE_ENV === 'development') {
        ws.on('data', function (msg) {
            // console.log('ws data', msg)
        })
    }

    var modelState = Object.keys(models).reduce((acc, k) => {
        acc[k] = Model.getState(models[k])
        return acc
    }, {})
    var state = struct(xtend(modelState, {
        editingAsset: observ(null),
        pendingEdits: observ(null),
        pendingDelete: observ(null),
        viewingAssetDetails: observ(null),
        fileTypeFilter: observ('all'),
        search: observ(null)
    }))

    if (process.env.NODE_ENV === 'development') {
        // set a status as transcoding
        window.transcode = function (progress) {
            var video = _.findWhere(state.assets.data.sorted(), {
                type: 'video'
            })

            models.assets.editSync(xtend(video, {
                currentStatus: 'transcoding',
                transcodeProgress: progress || 20
            }))
        }

        window.addUpload = function () {
            models.assets.addSync({
                "assetID": "556e8f93f3f6aa19601e32b8d89b9493a270fc60",
                "clientID": "1000000000",
                "eventID": null,
                "name": "file upload test.png",
                "type": "upload",
                "dateCreated": "2018-12-20 15:41:22",
                "fileSize": "220182",
                "totalRunTime": null,
                "totalRunTimeS": null,
                "currentStatus": "processing upload",
                "fileUrl": null,
                "thumbnail": "",
                "sprite": null,
                "liveID": null,
                "recStartDate": null,
                "recStopDate": null,
                "estRecDur": null,
                "path": null,
                "TTL": "2018-12-30 15:40:22",
                "advancedDetails": false,
                "previewURI": null
            })
        }

        window.pushError = function () {
            Model.getState(models.assets).requests.error.set({
                "req": {
                    "assetID": "3b8c3979c377b44c66ff25a0ace3e56d44dc2e88",
                    "clientID": "1000000000",
                    "eventID": null,
                    "name": "SampleVideo-720x480-5mb.mkv",
                    "type": "video",
                    "dateCreated": "2018-12-21 11:39:31",
                    "fileSize": "5250931",
                    "totalRunTime": "00:00:35",
                    "totalRunTimeS": 35,
                    "currentStatus": "archive",
                    "fileUrl": "https://invintus-mediaworkflow.s3.amazonaws.com/1000000000/3b8c3979c377b44c66ff25a0ace3e56d44dc2e88.mp4",
                    "thumbnail": "https://invintus-client-images.s3.amazonaws.com/1000000000/3b8c3979c377b44c66ff25a0ace3e56d44dc2e88.jpg",
                    "sprite": null,
                    "advancedDetails": {
                        "general": {
                            "filename": "3b8c3979c377b44c66ff25a0ace3e56d44dc2e88.mp4",
                            "format": "mpeg-4",
                            "filesize": 10569616,
                            "durationHMS": "00:00:35",
                            "durationS": 35,
                            "bitrate": 2382
                        },
                        "video": [
                            {
                                "format": "avc",
                                "bitrate": 2047,
                                "dimensions": {
                                    "width": "720",
                                    "height": "480"
                                },
                                "aspect_ratio": "3:2",
                                "framerate_mode": "Constant",
                                "frame_rate": "29.970 (30000/1001) FPS",
                                "stream_size": 9075143
                            }
                        ],
                        "audio": [
                            {
                                "format": "aac",
                                "title": "AAC",
                                "format_profile": "LC",
                                "bitrate": 330,
                                "channels": "2.0ch",
                                "stream_size": 1462518
                            }
                        ],
                        "image": null,
                        "text": null
                    }
                },
                "type": "delete",
                "id": 2,
                "error": new Error('Asset cannot be removed since it is assigned as part of an Ad Campaign, remove the asset from the campaign before deleting the asset')
            })
        }
    }

    // create dom event handlers
    var eventHandlers = {
        onFilterChange: function (ev) {
            state.fileTypeFilter.set(ev.target.value)
        },

        onSearchChange: function (ev) {
            state.search.set(ev.target.value)
        },

        onEdit: function (asset) {
            state.editingAsset.set(asset)
            state.pendingEdits.set({ name: asset.name })
        },

        onCancelEdit: function () {
            state.editingAsset.set(null)
            state.pendingEdits.set(null)
        },

        onEditChange: function (newValues) {
            state.pendingEdits.set({
                name: newValues.name
            })
        },

        onSubmitEdit: function () {
            models.assets.edit({
                assetID: state.editingAsset().assetID,
                name: state.pendingEdits().name
            }, function (err, res) {
                if (err) return
                state.editingAsset.set(null)
                state.pendingEdits.set(null)
            })
        },

        onDelete: function (asset) {
            state.pendingDelete.set(asset)
        },

        onConfirmDelete: function (asset) {
            models.assets.delete(asset, function (err, res) {
                if (err) return
                state.pendingDelete.set(null)
            })
        },

        onCancelDelete: function (asset) {
            state.pendingDelete.set(null)
        },

        onCloseModal: function () {
            state.viewingAssetDetails.set(null)
        },

        onViewDetails: function (asset) {
            state.viewingAssetDetails.set(asset)
        },

        onSortChange: function (ev) {
            models.assets.sortBy(ev.target.value)
        },

        onSortOrderChange: function (ev) {
            ev.preventDefault()
            models.assets.orderBy(state.assets.data.order() === 'asc' ?
                'desc' : 'asc')
        },

        onHideErrorModal: function (ev) {
            models.assets.clearError()
        }
    }

    var uppy = api.getUppy()

    // these are placeholder assets indexed by the upload id. This way
    // we can delete the asset if the upload fails
    var pendingUploads = {}

    // uppy.on('complete', function (res) {
    //     // all uploads are done
    //     console.log('complete', arguments)
    // })

    // uppy.on("file-removed", function (file) {
    //     console.log('file removed', file)
    // })

    // uppy.on("file-added", function (file) {
    //     console.log("file added", arguments)
    // })

    // uppy.on("upload-success", function () {
    //     console.log('upload success', arguments)
    // })

    // uppy.on('upload-error', function (file, err) {
    //     console.log('upload err', arguments)
    //     var asset = pendingUploads[file.id]
    //     if (!asset) return
    //     models.assets.deleteSync(asset)
    // })

    // uppy.on('upload', function (ev) {

    //     ev.fileIDs.forEach(function (id) {
    //         var file = uppy.getFile(id)
    //         models.assets.getPlaceholder({
    //             eventID: 'MISC',
    //             fileName: slugify(file.name),
    //             fileSize: file.size
    //         })
    //     })
    // })

    // do things when the route loads
    models.assets.get({ advancedDetails: true })

    class MiscAssets extends React.Component {
        constructor (props) {
            super(props)
            this.state = state()
        }

        componentDidMount () {
            // connect state
            var self = this

            this._unsub = batchUpdates(state)(function onChange (_state) {
                self.setState(_state)
            })
        }

        componentWillUnmount () {
            this._unsub()
        }

        render () {
            return <div className="misc-assets-route">
                <View {...this.props} {...this.state} {...eventHandlers}
                    uppy={uppy} />
            </div>
        }
    }

    return MiscAssets
}

export default MiscAssetsRoute


var defer = (typeof Promise === 'function') ?
    Promise.resolve().then.bind(Promise.resolve()) :
    window.setTimeout

// this is nastier than i expected, but it seems like react state
// doesn't work with the form inputs when it's updated async. So we
// want to batch some of our state changes, but keep form related state
// changes synchronous.
// we set state synchronously on the first call, but then batch any
// subsequent calls that are in the same frame
function batchUpdates (state) {
    var batched = observ(null)
    var _update
    var isPending = false
    var hasUpdate = false

    state(function onChange (_state) {
        // batch synchronous calls to setState
        if (!isPending) {
            batched.set(_state)
            isPending = true
            defer(function () {
                if (hasUpdate) batched.set(_update)
                isPending = false
                hasUpdate = false
            })
            return
        }

        // isPending
        _update = _state
        hasUpdate = true
    })

    return batched
}
